<!-- 库存页面 -->
<template>
  <div class="inventory">
    <div class="page_title">
      <custom-breadcrumb/>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%;min-height: calc(100vh - 400px);margin-bottom: 92px;"
    >
      <el-table-column
        label="Name">
        <template slot-scope="scope">
          <div class="table-name">
            <el-image
              class="pro-image"
              :src="scope.row.imgPath"
              fit="cover"></el-image>
            <span>{{ scope.row.skuName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="Created"
        width="200"
      >
        <template slot-scope="scope">
          {{ $tool.formatDateTime(scope.row.createAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="Reason"
        width="200"
      >
        <template slot-scope="scope">
          {{ scope.row.type === 1 ? 'In-warehouse' : 'Ex-warehouse' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="num"
        label="Qty"
        width="200"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type === 1">+ {{ scope.row.num }}</div>
          <div v-else>- {{ scope.row.num }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="balanceNum"
        label="Inventory"
        width="200"
      />
    </el-table>
    <div class="page_table" v-if="tableData.length>0">
      <pagination
        :currentPage="pageConfigs.current_page"
        :total="total"
        :pageSize="pageConfigs.page_size"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '../components/pagination'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import {getAction} from '../../api/manage'

export default {
  name: 'SkuInventory',
  components: {
    CustomBreadcrumb,
    Pagination
  },
  data() {
    return {
      skuId: '',
      total: 0,
      pageConfigs: {
        current_page: 1,
        page_size: 10
      },
      tableData: []
    }
  },
  mounted() {
    this.skuId = this.$route.query.id
    this.loadData()
  },

  methods: {

    loadData() {
      getAction(`/product/api/v0.2/skus/${this.skuId}/inventory_logs`, this.pageConfigs).then(res => {
        if (res.code === 200) {
          this.total = res.result.total
          this.tableData = res.result.records
        }
      }).catch(() => {
      })
    },

    handleSizeChange(pageSize) {
      this.pageConfigs.page_size = pageSize
      this.pageConfigs.current_page = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.pageConfigs.current_page = currentPage
      this.loadData()
    }
  }
}
</script>

<style lang="less" scoped>
.page_table {
  background: #FFFFFF;
  width: 100%;
  position: fixed;
  bottom: 0px;
  z-index: 2;
}

.inventory {
  font-size: 14px;
  font-family: Graphik;

  .page_title {
    margin: 10px 30px 30px 0px !important;
  }

  .table-name {
    width: 100%;
    display: flex;
    flex-direction: row;

    align-items: center;
    margin-right: 4px;

    .pro-image {
      border: 1px solid #E8E8E8;
      margin-right: 4px;

      /deep/ .el-image__inner {
        width: 80px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/produts/sku-inventory.vue